(() => {
  let previousMenuOpen = false;
  let previousSubmenu = null;
  let menuFocusTimer;
  const setHidden = (element, hidden) => {
    if (!element) return;
    element.toggleAttribute("inert", hidden);
    element.setAttribute("aria-hidden", String(hidden));
  };
  const focusFirst = (element) => {
    const target = Array.from(element?.querySelectorAll('a[href], button:not(:disabled), [tabindex="0"]') || [])
      .find(item => !item.closest('[inert]'));
    target?.focus();
  };
  const syncDesktopMenu = () => {
    document.querySelectorAll("[data-popup-item]").forEach((item) => {
      const trigger = item.querySelector("[data-popup-trigger]");
      if (!trigger) return;

      const popupId = trigger.getAttribute("aria-controls");
      const popup = popupId ? document.getElementById(popupId) : null;
      const expanded = item.classList.contains("active") || popup?.style.zIndex === "200";

      trigger.setAttribute("aria-expanded", expanded ? "true" : "false");
    });
  };

  const syncMobileMenu = () => {
    const menu = document.getElementById("ekrin-mobile-menu") || document.querySelector(".header-menu__mobile-menu");
    const button = document.querySelector(".header-menu__open-menu-button");

    if (menu && button) {
      const open = menu.hasAttribute("data-open");
      const submenu = open ? menu.querySelector(".header-menu__mobile-menu__submenu[data-open]") : null;
      const mainMenu = menu.querySelector(".header-menu__mobile-menu__main-menu");
      const restoreSubmenuFocus = open && previousSubmenu && !submenu && previousSubmenu.contains(document.activeElement);
      // Move focus out before hiding its current container.
      if (!open && previousMenuOpen && menu.contains(document.activeElement)) button.focus();
      setHidden(menu, !open);
      // Reveal the destination before focusing it; an inert parent rejects focus.
      if (submenu) setHidden(submenu, false);
      else setHidden(mainMenu, !open);
      if (open && submenu !== previousSubmenu && submenu) focusFirst(submenu);
      else if (open && !previousMenuOpen) focusFirst(menu);
      else if (restoreSubmenuFocus) menu.querySelector(`[data-submenu="${previousSubmenu.id}"]`)?.focus();
      setHidden(mainMenu, !open || !!submenu);
      menu.querySelectorAll(".header-menu__mobile-menu__submenu").forEach(panel => setHidden(panel, panel !== submenu));
      button.setAttribute("aria-expanded", String(open));
      previousMenuOpen = open;
      previousSubmenu = submenu;
    }

    document.querySelectorAll("[data-submenu]").forEach((trigger) => {
      const submenu = document.getElementById(trigger.getAttribute("data-submenu"));
      trigger.setAttribute("aria-expanded", submenu?.hasAttribute("data-open") ? "true" : "false");
    });
  };

  const sync = () => {
    syncDesktopMenu();
    syncMobileMenu();
  };

  const syncAfterInteraction = () => {
    requestAnimationFrame(() => requestAnimationFrame(sync));
  };

  const handleKeydown = (event) => {
    if (event.key !== "Escape") {
      clearTimeout(menuFocusTimer);
      return;
    }

    const openSubmenu = document.querySelector(".header-menu__mobile-menu__submenu[data-open]");
    if (openSubmenu) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openSubmenu.querySelector("[data-close-submenu]")?.click();
      syncAfterInteraction();
      return;
    }

    const menu = document.getElementById("ekrin-mobile-menu") || document.querySelector(".header-menu__mobile-menu");
    const button = document.querySelector(".header-menu__open-menu-button");
    if (menu?.hasAttribute("data-open")) {
      event.preventDefault();
      event.stopImmediatePropagation();
      // Move focus before the animated close hides/inerts the focused item.
      // Browsers may already blur it by the time the observer runs.
      button?.focus();
      button?.click();
      syncAfterInteraction();
      clearTimeout(menuFocusTimer);
      // The legacy header animates for 300ms, then its debounced body-resize
      // handler refreshes the pinned header. That refresh can blur the trigger.
      menuFocusTimer = setTimeout(() => {
        if (menu.hasAttribute("data-open") || !button?.isConnected || !button.getClientRects().length) return;
        if (document.activeElement === document.body || menu.contains(document.activeElement)) {
          button.focus({ preventScroll: true });
        }
      }, 600);
    }
  };

  const observeMenuState = () => {
    const observer = new MutationObserver(sync);
    document.querySelectorAll("[data-popup-item], .header-menu-popup__item, [data-submenu], .header-menu__mobile-menu, .header-menu__mobile-menu__submenu").forEach((element) => {
      observer.observe(element, {
        attributes: true,
        attributeFilter: ["class", "data-open", "style"],
      });
    });
  };

  document.addEventListener("click", syncAfterInteraction);
  document.addEventListener("keydown", handleKeydown, true);
  document.addEventListener("pointerdown", () => clearTimeout(menuFocusTimer), true);
  window.addEventListener("resize", () => {
    const menu = document.getElementById("ekrin-mobile-menu") || document.querySelector(".header-menu__mobile-menu");
    const button = document.querySelector(".header-menu__open-menu-button");
    if (menu?.hasAttribute("data-open") && button && !button.getClientRects().length) {
      menu.removeAttribute("data-open");
      menu.querySelectorAll("[data-open]").forEach(panel => panel.removeAttribute("data-open"));
      document.querySelector(".header-menu")?.removeAttribute("data-open");
      document.body.classList.remove("no-scroll");
      // The mobile trigger is hidden at this breakpoint, so don't focus it.
      previousMenuOpen = false;
      previousSubmenu = null;
      sync();
    }
  });
  document.addEventListener("DOMContentLoaded", () => {
    sync();
    observeMenuState();
  });
  window.addEventListener("load", sync);
})();
